import React from 'react';

import { H1 } from '@aurora/widgets-react';

const NotFound = () => (
  <React.Fragment>
    <H1>Not Found</H1>
  </React.Fragment>
);

export default NotFound;
